var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"small":_vm.small,"color":"primary"}},[_vm._v(" "+_vm._s(_vm.label || _vm.$t("nav_buttons.add"))+" "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v(" mdi-plus ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }